// Server page size for the send-event list (offset = page * HISTORY_PAGE_SIZE).
export const HISTORY_PAGE_SIZE = 10;
// Server page size for a single send's recipient rows (loaded on expand).
export const HISTORY_ITEMS_PAGE_SIZE = 25;
// Poll cadence for the open history list while any visible event is unsettled —
// modest, since delivery is bounded by the ~5-min background processor cadence.
export const HISTORY_POLL_INTERVAL_MS = 10000;
